import { useContext, useState } from 'react';
import { initRequiredFields, DocumentObject, ItemList, FormDataApis, SelectOptions } from '../ApisForm.model';
import {
	ApisFormContext,
	getModelInfant,
	minMaxDateExpiryDate,
	transformRequiredFields,
	transformRequiredFieldsOptions
} from '../ApisForm.utils';
import {
	OthersOptions,
	RequiredField,
	RequiredFieldOptions,
	RequiredFieldTypes
} from '../components/DocumentationRequired/DocumentationRequired.model';
import { useFormContext } from 'react-hook-form';
import { InputAutocompleteOption } from '../../../forms/input-autocomplete';
import { InputSelectOption } from '../../../forms/input-date-select/types/InputDateSelectTransformerTypes';
import { DocOtherFields } from '../ApisForm.constants';

type UseOthersDocumentsProps = {
	config: DocumentObject[];
	styles: CSSModuleClasses;
	options?: OthersOptions;
	isInfant?: boolean;
};

export const useOthersDocuments = ({ config, styles, options, isInfant = false }: UseOthersDocumentsProps) => {
	const [isCollapsed, setCollapsed] = useState(false);
	const [requiredFields, setRequiredFields] = useState<RequiredField>(initRequiredFields);
	const [requiredFieldsOptions, setRequiredFieldsOptions] = useState<RequiredFieldOptions[] | undefined>(undefined);
	const marginCollapse: string = isCollapsed ? '' : styles.margin_collapse;
	const { isFormDisabled = false } = useContext(ApisFormContext);

	const { setValue, resetField } = useFormContext<FormDataApis>();

	const { minDate, maxDate } = minMaxDateExpiryDate();
	const modelInfant = getModelInfant(isInfant);

	const getRequiredFieldsOptions = (
		type: RequiredFieldTypes,
		options?: RequiredFieldOptions[]
	): SelectOptions | undefined => {
		const dataOptions = options ? options : requiredFieldsOptions;
		const option = dataOptions?.find((element) => {
			return element.type === type && element.defaultValues ? element : undefined;
		});

		return option ? option.defaultValues : undefined;
	};

	const handleChangeType = (newValue: InputAutocompleteOption | InputSelectOption) => {
		const configSelected: DocumentObject | undefined = config.find((document: DocumentObject) => {
			const docTypeModel = document.type as ItemList;
			return docTypeModel.code === newValue.value ? document : undefined;
		});
		if (configSelected?.requiredFields) {
			const newRequiredFields = transformRequiredFields(configSelected.requiredFields);

			setRequiredFields((prevState) => {
				return { ...prevState, ...newRequiredFields };
			});
		}
		if (options?.countries) {
			const newRequiredFieldsOptions = transformRequiredFieldsOptions(
				configSelected?.requiredFieldsOptions,
				options.countries
			);

			if (Array.isArray(newRequiredFieldsOptions)) {
				setRequiredFieldsOptions(newRequiredFieldsOptions);
				newRequiredFieldsOptions.forEach(({ type }) => {
					const field = getRequiredFieldsOptions(type as RequiredFieldTypes, newRequiredFieldsOptions) as SelectOptions;
					if (type === 'issuerCountry') setValue(DocOtherFields.ISSUER_COUNTRY, field);
					if (configSelected?.requiredFields?.includes('EXPIRY_DOC')) setValue(DocOtherFields.EXPIRY_DATE, undefined);
				});
			}
		}
	};

	return {
		isCollapsed,
		setCollapsed,
		requiredFields,
		getRequiredFieldsOptions,
		marginCollapse,
		handleChangeType,
		setValue,
		resetField,
		minDate,
		maxDate,
		modelInfant,
		isFormDisabled
	};
};
